/**
 * Tertiary Nav
 */

// Vendors
import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';

$('body').on('click', (event) => {
  const dropdown = $('.nav-tertiary__menu');
  hideDropdown(dropdown);
});

// Apply localscroll
$('.nav-tertiary').localScroll({
  duration: 1000,
  easing: 'easeInOutExpo',
  offset: -155
});

$('[data-nav-tertiary-show]').on('click', (event) => {
  event.preventDefault();
  event.stopPropagation();

  const menu = $('.nav-tertiary__menu');

  if (!menu.hasClass('nav-tertiary__menu--visible')) {
    showDropdown(menu);
  } else {
    hideDropdown(menu);
  }
});

// Set Scroll Posistions
let scroll_positions = [];
$('.nav-tertiary__menu-dropdown li a').each((index, elem) => {
  const hash = elem.hash.replace('#', '');
  const text = elem.text.trim();
  const $section = $('#' + hash);
  const sectionOffset = $section.offset();

  if (hash && sectionOffset) {
    const posistion = $('#' + hash).offset().top;
    scroll_positions[text] = posistion;
  }
});

function showDropdown(menu) {
  $('.site-header-desktop__bottom .site-header-desktop__content').css({
    overflow: 'visible'
  });
  setTimeout(() => {
    menu.addClass('nav-tertiary__menu--visible');
  });
}

function hideDropdown(menu) {
  menu.scrollTop(0);
  menu.removeClass('nav-tertiary__menu--visible');
  setTimeout(() => {
    $('.site-header-desktop__bottom .site-header-desktop__content').css({
      overflow: ''
    });
    $('.nav-tertiary__menu-dropdown').scrollTop(0);
  }, 150);
}

// Hide/show menu based on scroll direction
let previousWindowScrollPosition = 0;

$(() => handleScroll());
$(window).on('load scroll', () => handleScroll());

function handleScroll() {
  $('.site-header-desktop__bottom .site-header-desktop__content').css({
    overflow: ''
  });
  $('.nav-tertiary__menu').removeClass('nav-tertiary__menu--visible');
  $('.nav-tertiary__menu-dropdown').scrollTop(0);

  const windowScrollPosition = $(window).scrollTop();
  const direction =
    windowScrollPosition > previousWindowScrollPosition ? 'down' : 'up';

  if (windowScrollPosition > 199) {
    $('body').addClass('scrolled-past-page-content');

    if (direction === 'down') {
      $('body').addClass('scrolling-down');
      $('body').removeClass('scrolling-up');
    } else {
      $('.site-header-desktop__bottom .site-header-desktop__content').css({
        overflow: 'hidden'
      });

      $('body').addClass('scrolling-up');
      $('body').removeClass('scrolling-down');
    }
  } else {
    $('body').removeClass('scrolled-past-page-content');
  }

  // Anchor Link Index Based on Scroll Posistion
  let anchor_link_index = '';
  let current_index = '';
  for (var index in scroll_positions) {
    if (windowScrollPosition + 175 > scroll_positions[index]) {
      anchor_link_index = index;
    }
  }
  if (anchor_link_index) {
    $('a.nav-tertiary__menu-toggle span.nav-tertiary__menu-toggle-title').html(
      anchor_link_index
    );
  }

  previousWindowScrollPosition = windowScrollPosition;
}
